module.exports = __webpack_public_path__ + "adb38c338cdcdb3f81fe44d8d726e1b7.png";